var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"cursor":"pointer"}},[(_vm.partnerCode==='apex_tz')?_c('span',{staticClass:"white--text text-h5"},[_vm._v("eMazao")]):_c('Logo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }